import React, { useEffect, useState } from "react";
import axios from "axios";
import fetchBase64Image from "../helpers/fetchBase64Image";

interface QuizQuestionProps {
  questionId: number;
  options: string[];
  onAnswerSelected: (selectedOption: string) => void;
}

const QuizQuestionMain: React.FC<QuizQuestionProps> = ({
  questionId,
  options,
  onAnswerSelected,
}) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [mode, setMode] = useState<"mobile" | "desktop">(
    window.innerWidth < 768 ? "mobile" : "desktop"
  );
  const fetchImage = async (currentMode: "mobile" | "desktop") => {
    const result = await fetchBase64Image(questionId, currentMode);
  
    if (result && result.image) {
      setImageSrc(result.image);
    }
  };

  useEffect(() => {
    fetchImage(mode);
  }, [mode, questionId]);

  useEffect(() => {
    const handleResize = () => {
      const newMode = window.innerWidth < 768 ? "mobile" : "desktop";
      setMode((prevMode) => (prevMode !== newMode ? newMode : prevMode));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      {imageSrc && (
        <img
          src={imageSrc}
          alt="Pitanje"
          className={mode === "mobile" ? "mobile-image" : "desktop-image"}
        />
      )}

      <div className="odgovori">
        {options.map((selectedOption, index) => (
          <button key={index} onClick={() => onAnswerSelected(selectedOption)}>
            {selectedOption}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuizQuestionMain;
